import "@livekit/components-styles";
import "@livekit/components-styles/prefabs";
import type { AppProps } from "next/app";
import Head from "next/head";
import "../styles/globals.css";

function MyApp({ Component, pageProps }: AppProps) {
  return (
    <>
      <Head>
        <title>Telmeda</title>
        <link rel="icon" href="/daiko_icononly_transparent_nobuffer.png" />
      </Head>

      <Component {...pageProps} />
    </>
  );
}

export default MyApp;
